import { createStructuredSelector } from 'reselect';
import { fetchRAGState } from './RecommendGrantPageSelectors';

const selectPurpose = (state) => {
  const { purpose } = fetchRAGState(state);
  return purpose;
};

const selectProject = (state) => {
  const { project } = fetchRAGState(state);
  return project;
};

export const grantPurposeDerivedStates = createStructuredSelector({
  purpose: selectPurpose,
  project: selectProject,
});
